// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1jQg4","label":"Category_label__3w1dB","content":"Category_content__3IdFa","header":"Category_header__3kv2d","location":"Category_location__v-r3s"};